export const RECEIVE_CONTACTS = "RECEIVE_CONTACTS";
export const RECEIVE_TRADE_DOCUMENT_CONTACTS = "RECEIVE_TRADE_DOCUMENT_CONTACTS";



// WEBPACK FOOTER //
// ./src/features/contacts/contactsActionTypes.js